import { createStore } from 'vuex'

export default createStore({
    state: {
        aid: '67077db384ebbd0039b1e313', // 活动id
        userInfo: {}, // 用户信息
        dialogData: null, // 弹框数据
        activityData: null, // 活动数据
        shareData: {}, // 分享信息
        picViewerData: null
    },
    mutations: {
        SET_AID (state, aid: string) {
            state.aid = aid
        },
        SET_USERINFO (state, data) {
            state.userInfo = data
        },
        SET_DIALOGDATA (state, data) {
            state.dialogData = data
        },
        SET_ACTIVITYDATA (state, data) {
            state.activityData = data
        },
        SET_SHAREDATA (state, data) {
            state.shareData = data
        },
        SET_PICVIEWERDATA (state, data: any) {
            state.picViewerData = data
        },
    },
    actions: {
    },
    modules: {
    }
})
